import { useQueryClient } from "@tanstack/react-query";
import { GraphQLClient } from "graphql-request";

import { Day } from "../../generated-types";
import {
  GetDaysByUserQuery,
  GetDaysByUserQueryVariables,
  useGetDaysByUserQuery
} from "../../queries/days/index.generated";
import {
  useSetIsSickMutation,
  useSetVacationsMutation
} from "./index.generated";

export const useSetVacations = ({
  day,
  updateCurrentDay,
  client,
  variables
}: {
  day: Day | undefined | null;
  updateCurrentDay: (acation: boolean) => void;
  client: GraphQLClient;
  variables: GetDaysByUserQueryVariables;
}) => {
  const queryClient = useQueryClient();

  const { mutateAsync: setVacations, ...options } = useSetVacationsMutation(
    client,
    {
      onSuccess: (data) => {
        const daysData: GetDaysByUserQuery | null | undefined =
          queryClient.getQueryData(useGetDaysByUserQuery.getKey(variables));

        const newData: Day[] = [];

        // console.log("data?.setVacations ", data?.setVacations);
        data?.setVacations?.nodes?.forEach((item) => {
          if (item.date === day?.date) {
            console.log("save");
            daysData?.days?.forEach((_day) => {
              if (day?.documentId === _day?.documentId) {
                newData.push(item as Day);
              } else {
                newData.push(_day as Day);
              }
            });
            // salvo lo stato della vacanza del giorno corrente
            updateCurrentDay(item.vacation ?? false);
          }
        });

        const _data = {
          days: newData
        };

        if (daysData) {
          queryClient.setQueryData(
            useGetDaysByUserQuery.getKey(variables),
            (_old) => _data
          );
        }
      }
    }
  );

  return { setVacations, options };
};

export const useSetIsSick = ({
  client,
  variables
}: {
  client: GraphQLClient;
  variables: GetDaysByUserQueryVariables;
}) => {
  const queryClient = useQueryClient();

  const { mutateAsync: setIsSick, ...options } = useSetIsSickMutation(client, {
    onSuccess: (data) => {
      const daysData: GetDaysByUserQuery | null | undefined =
        queryClient.getQueryData(useGetDaysByUserQuery.getKey(variables));

      const newData: Day[] = [];

      const sickDay = data?.setIsSick;
      daysData?.days?.forEach((_day) => {
        if (sickDay?.data?.documentId === _day?.documentId) {
          newData.push(sickDay?.data as Day);
        } else {
          newData.push(_day as Day);
        }
      });

      const _data = {
        days: newData
      };

      if (daysData) {
        queryClient.setQueryData(
          useGetDaysByUserQuery.getKey(variables),
          (_old) => _data
        );
      }
    }
  });

  return { setIsSick, options };
};
